import React, { useRef } from 'react'

import styled from 'styled-components'
import { Toaster } from 'react-hot-toast'

import PersonalInformation from './components/PersonalInformation'
import EducationalBackgrounds from './components/EducationalBackgrounds'
import JobExperiences from './components/JobExperiences'
import Skills from './components/Skills'
import CharacterReferences from './components/CharacterReferences'
import ReviewCV from './components/ReviewCV'
import CircularMultiStepForm from '../../components/CircularMultiStepForm'

import AuthLayouts from '../../layouts/AuthLayouts'

const ManageProfile = () => {
  const formRef = useRef(null)
  const steps = [
    {
      value: 1,
      text: 'Personal Information',
      active: true,
      disabled: false,
      form: <PersonalInformation ref={formRef} />,
    },
    {
      value: 2,
      text: 'Educational Backgrounds',
      active: false,
      disabled: true,
      form: <EducationalBackgrounds ref={formRef} />,
    },
    {
      value: 3,
      text: 'Job Experiences',
      active: false,
      disabled: true,
      form: <JobExperiences ref={formRef} />,
    },
    {
      value: 4,
      text: 'Skills',
      active: false,
      disabled: true,
      form: <Skills ref={formRef} />,
    },
    {
      value: 5,
      text: 'Character References',
      active: false,
      disabled: true,
      form: <CharacterReferences ref={formRef} />,
    },
    {
      value: 6,
      text: 'Review CV',
      active: false,
      disabled: true,
      form: <ReviewCV ref={formRef} />,
    },
  ]

  return (
    <AuthLayouts width="750px">
      <StyledManageProfileForm>
        <Toaster position="top-right" reverseOrder={false} />
        <CircularMultiStepForm
          steps={steps}
          multiStepFormName="vacancyRequest"
          formRef={formRef}
        />
      </StyledManageProfileForm>
    </AuthLayouts>
  )
}

export const StyledManageProfileForm = styled.section`
  width: 100%;
  display: flex;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export default ManageProfile
